import { ReactNode } from 'react';
import { useNodeEvents } from '@/GraphEditor/drawingLayer/contexts/NodeEventsContext';
import { cn } from '@/lib/utils';

interface Props {
    color: string;
    className?: string;
    children: ReactNode;
    straightTopLeftCorner?: boolean;
    straightTopRightCorner?: boolean;
    straightBottomLeftCorner?: boolean;
    straightBottomRightCorner?: boolean;
}

export const NodeBackground: React.FC<Props> = ({
    color,
    className,
    children,
    straightTopLeftCorner,
    straightTopRightCorner,
    straightBottomLeftCorner,
    straightBottomRightCorner,
}) => {
    const { onClick, handleMouseDown, handleMouseUp } = useNodeEvents();

    const borderRadiusClasses = cn('rounded-[10px]', {
        '!rounded-tl-none': straightTopLeftCorner,
        '!rounded-tr-none': straightTopRightCorner,
        '!rounded-bl-none': straightBottomLeftCorner,
        '!rounded-br-none': straightBottomRightCorner,
    });

    return (
        <div
            className={cn('pointer-events-auto select-none backdrop-blur-sm border border-white/20', className, borderRadiusClasses)}
            style={{
                backgroundColor: `${color}80`, // 80 = 50% opacity in hex
                background: `${color}80`,
            }}
            onClick={e => {
                e.preventDefault();
                e.stopPropagation();
                onClick(e);
            }}
            onPointerDown={handleMouseDown}
            onPointerUp={handleMouseUp}
        >
            {children}
        </div>
    );
};
